import { useEffect, useMemo, useState } from 'react';

const useIsVisible = (): {
  isVisible: boolean;
  registerElement: (element: Element) => void;
} => {
  const [isVisible, setIsVisible] = useState(false);

  // Intersection observer to check DOM element visibility
  const visibilityObserver = useMemo(() => {
    if (!global.window) return null;

    return new IntersectionObserver(([componentElement]) => {
      setIsVisible(componentElement.isIntersecting);
    });
  }, []);

  const registerElement = (element: Element) => {
    if (!visibilityObserver) return;
    visibilityObserver.observe(element);
  };

  useEffect(() => {
    return () => {
      visibilityObserver?.disconnect();
    };
  }, [visibilityObserver]);

  return { isVisible, registerElement };
};

export default useIsVisible;
